import { StatusDropdown } from "components";
import MoveFreefieldProfilePaginatedDropdown from "components/dropdowns/paginated/MoveFreefieldProfilePaginatedDropdown";
import FreeFieldCategoryDropdown from "components/dropdowns/reactselect/FreeFieldCategoryDropdown";
import Modal from "components/modal";
import React from "react";
import { Button } from "semantic-ui-react";

interface Props<T> {
  title: string
  afterDeleteRedirectUrl: string
  isOpen: boolean
  onClose: () => void
  renderSelect: (value: T | null, onChange: (value: T | null) => void, error: boolean) => React.ReactNode
  deleteFunc: (selectedItem: T) => Promise<any>
}

const DeleteAndMustMoveItems = <T extends any>(props: Props<T>) => {
  const [deleting, setDeleting] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<T | null>(null);
  const [selectItemError, setSelectItemError] = React.useState<boolean>(false);

  const onDelete = async () => {
    if (!selectedItem) {
      setSelectItemError(true);
      return;
    }

    setDeleting(true);
    await props.deleteFunc(selectedItem);
    window.location.href = props.afterDeleteRedirectUrl;
    setDeleting(false);
  };

  return (
    <Modal
      isOpen={props.isOpen}
      width="mini"
      handleClose={props.onClose}
      title={RESX.Buttons.btnDelete}
      className="force_z"
    >
      <div className="margin-bottom">
        {props.title}
      </div>
      <div className="margin-bottom-big">
        {props.renderSelect(selectedItem, (v) => { setSelectedItem(v); setSelectItemError(false) }, selectItemError)}
      </div>
      <div className="flex">
        <div className="grow1"></div>
        <div>
          <Button
            color="red"
            onClick={onDelete}
            content={RESX.Buttons.btnDelete}
            name="Delete"
            loading={deleting}
          />
        </div>
      </div>
    </Modal>
  );
};

interface DeleteAndMustMoveStatusProps {
  statusId: number
  afterDeleteRedirectUrl: string
  isOpen: boolean
  onClose: () => void
  mainArea: server.dto.MainAreas
  clientId: number
}

export const DeleteAndMustMoveStatus = (props: DeleteAndMustMoveStatusProps) => {
  return <DeleteAndMustMoveItems<server.dto.StatusSmall>
    title={RESX.Status.AllItemsWithThisStatus}
    afterDeleteRedirectUrl={props.afterDeleteRedirectUrl}
    isOpen={props.isOpen}
    onClose={props.onClose}
    renderSelect={(value, onChange, error) => (
      <StatusDropdown
        value={value}
        onChange={onChange}
        config={{
          hasError: error
        }}
        mainArea={props.mainArea}
        clientId={props.clientId}
        options={undefined}
        excludeKeys={[props.statusId]}
      />
    )}
    deleteFunc={(selectedItem) => window.CoreApi.Status.DeleteAndMove(props.statusId, selectedItem.statusId)}
  />
}

interface DeleteAndMustMoveFreeFieldCategoryProps {
  freeFieldCategoryId: number
  afterDeleteRedirectUrl: string
  isOpen: boolean
  onClose: () => void
  mainArea: server.dto.MainAreas
}

export const DeleteAndMustMoveFreeFieldCategory = (props: DeleteAndMustMoveFreeFieldCategoryProps) => {
  return <DeleteAndMustMoveItems<server.dto.FreeFieldCategoryForList>
    title={RESX.FreeField.AllFreeFieldsInThisCategory}
    afterDeleteRedirectUrl={props.afterDeleteRedirectUrl}
    isOpen={props.isOpen}
    onClose={props.onClose}
    renderSelect={(value, onChange, error) => (
      <FreeFieldCategoryDropdown
        value={value}
        onChange={onChange}
        config={{
          hasError: error
        }}
        mainArea={props.mainArea}
        options={undefined}
        excludeKeys={[props.freeFieldCategoryId]}
      />
    )}
    deleteFunc={(selectedItem) => window.CoreApi.FreeFieldCategory.DeleteAndMove({
      freeFieldCategoryId: props.freeFieldCategoryId,
      targetFreeFieldCategoryId: selectedItem.freeFieldCategoryId
    })}
  />
}

interface DeleteAndMustMoveFreeFieldProfile {
  freeFieldProfileId: number
  afterDeleteRedirectUrl: string
  isOpen: boolean
  onClose: () => void
  environment: server.dto.Environments
}

export const DeleteAndMustMoveFreeFieldProfile = (props: DeleteAndMustMoveFreeFieldProfile) => {
  return <DeleteAndMustMoveItems<server.dto.FreeFieldProfileForList>
    title={RESX.FreeField.WhatShouldHappen}
    afterDeleteRedirectUrl={props.afterDeleteRedirectUrl}
    isOpen={props.isOpen}
    onClose={props.onClose}
    renderSelect={(value, onChange, error) => (
      <MoveFreefieldProfilePaginatedDropdown
        value={value}
        onChange={onChange}
        config={{
          hasError: error
        }}
        environment={props.environment}
        excludeKeys={[props.freeFieldProfileId]}
      />
    )}
    deleteFunc={(selectedItem) => window.CoreApi.FreeFieldProfile.DeleteFreeFieldProfile({
      freeFieldProfileId: props.freeFieldProfileId,
      moveToFreefieldProfileId: selectedItem.freeFieldProfileId
    })}
  />
}